import { render, staticRenderFns } from "./JobApplicationCount.vue?vue&type=template&id=72284782"
import script from "./JobApplicationCount.vue?vue&type=script&lang=js"
export * from "./JobApplicationCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports